<span class="ui-alert__title"
      [ngClass]="{
        'd-none': !label,
        }"
>
    <i class="{{iconClass}} m-r-4px"></i>
    {{ label }}
</span>
<span #content
      [ngClass]="{
        'display-none': !showText,
        'ui-alert__title': !label,
        'ui-alert__text': label
        }"
>
    <i class="{{iconClass}} m-r-4px {{!!label ? 'd-none' : ''}}"></i>
    <ng-content></ng-content>
</span>

